import { render, staticRenderFns } from "./ListarTipoLiquidacion.vue?vue&type=template&id=4fbb314c&"
import script from "./ListarTipoLiquidacion.vue?vue&type=script&lang=js&"
export * from "./ListarTipoLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports